export class Pagination {
  id:number;
  nombre_pages:number;
}
